// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXWrapper_base--1RGQa","base__overlayOpened":"WGCWXWrapper_base__overlayOpened--mx9zj","baseOverlayOpened":"WGCWXWrapper_base__overlayOpened--mx9zj","about":"WGCWXWrapper_about--vXKPx","close":"WGCWXWrapper_close--_AjW-"};


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXWrapper/WGCWXWrapper.scss
// module id = 2425
// module chunks = 11